import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import operateCenter from './modules/operate-center'
import orderCenter from './modules/order-center'
import enterpriseCenter from './modules/enterprise-center'
import serviceCenter from './modules/service-center'
import inventoryCenter from './modules/inventory-center'
import distributionCenter from './modules/distribution-center'
export const asyncRoutes = [
  ...operateCenter,
  ...orderCenter,
  ...enterpriseCenter,
  ...serviceCenter,
  ...inventoryCenter,
  ...distributionCenter
]

export const constantRoutes = [
  {
    name: "index",
    path: "/",
    component: () => import("@/views/index"),
    children: []
  },
  {
    name: "login",
    path: "/login",
    component: () => import("@/views/login"),
  },
  { // 运营数据看板-大屏
    name: "dataBoard",
    path: "/dataBoard",
    component: () => import("@/views/dataBoard"),
  },
  {
    hide: true,
    path: '/:pathMatch(.*)*',
    component: () => import('@/views/error/404'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRoutes
})

export default router
